export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
    fixed: 'left',
  },
  {
    title: that.$l('table_label_custCategoryNameEn') || '英文品类名称',
    field: 'custCategoryNameEn',
    headerAlign: 'center',
    align: 'left',
    minWidth: 220,
  },
  {
    title: that.$l('table_label_custCategoryName') || '中文品类名称',
    field: 'custCategoryName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 220,
  },
  {
    title: that.$l('table_label_updateInfo') || '数据更新',
    field: 'updateInfo',
    minWidth: 170,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'updateInfo' },
  },
]
